<template>
  <div style="height: 100%; display: flex; flex-direction: column">
    <div
      style="
        width: 100%;
        height: 80px;
        background-color: #fff;
        display: flex;
        flex-direction: row;
        gap: 20px;
        padding: 10px;
        box-sizing: border-box;
        border-bottom: 1px solid #ebedf0;
      "
    >
      <van-image
        width="50"
        height="50"
        radius="5"
        src="https://fastly.jsdelivr.net/npm/@vant/assets/cat.jpeg"
      />
      <div
        style="
          display: flex;
          flex: 1;
          flex-direction: column;
          margin-left: 10px;
          justify-content: space-between;
          box-sizing: border-box;
          overflow: auto;
        "
      >
        <span>{{ userInfo?.empName }}</span>
        <div
          style="
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div class="tag">
            本月签到<span class="highlight">{{ signCount }}</span
            >次
          </div>
          <!-- 时间选择 -->
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 6px;
              border: 1px solid #dcdee0;
              border-radius: 30px;
              box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
              padding: 6px 15px;
            "
            @click="showDatePop = true"
          >
            <van-icon name="calendar-o" />
            <span>{{ signDate }}</span>
            <van-icon name="arrow-down" />
          </div>
        </div>
      </div>
    </div>
    <div style="flex: 1; height: 100%; overflow: auto">
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        pull-distance="300"
      >
        <van-empty
          v-if="signList.length === 0"
          description="暂无数据"
          style="height: 100%"
        />
        <van-list style="height: 100%">
          <div
            v-for="(item, index) in signList"
            :key="index"
            style="
              display: flex;
              flex-direction: column;
              background-color: #fff;
              margin-bottom: 10px;
              box-sizing: border-box;
            "
          >
            <div
              style="
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 5px;
                padding: 10px 10px 0px;
              "
            >
              <span>{{ item.signDate }}</span>
              <van-divider vertical :hairline="false" />
              <span>签到{{ item.signCount }}次</span>
            </div>
            <div
              v-for="subItem in item.daySignInList"
              :key="subItem.signInId"
              style="
                display: flex;
                flex-direction: column;
                gap: 5px;
                border: 1px solid #ebedf0;
                box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
                border-radius: 5px;
                margin: 10px;
                padding: 10px;
              "
            >
              <div>
                {{ subItem.signTime }}
                {{ subItem.signType === 1 ? "内勤" : "外勤" }}
              </div>
              <span>签到地点</span>
              <span>{{ subItem.signAddress }}</span>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
  <van-popup v-model:show="showDatePop" position="bottom">
    <van-date-picker
      v-model="currentDate"
      :columns-type="['year', 'month']"
      title=""
      @confirm="confirmDate"
    />
  </van-popup>
</template>

<script setup lang="ts">
import { personList } from "@/api/sign";
import moment from "moment";
import { userAuthStore } from "@/store/auth";

const common = userAuthStore();
const userInfo = ref(common.currUserData);

const signCount = ref(0);
const signList: any = ref([]);

const refreshing = ref(false);
const onRefresh = () => {
  requestData();
};

// 选择时间
const currentDate = ref([
  moment().year().toString(),
  (moment().month() + 1).toString(),
]);
const showDatePop = ref(false);
const signDate = ref(moment().format("YYYY-MM"));
const confirmDate = () => {
  const [year, month] = currentDate.value;
  signDate.value = `${year}-${month}`;
  showDatePop.value = false;
  requestData();
};

const requestData = () => {
  personList({ signMonth: moment(signDate.value).format("YYYYMM") })
    .then((res: any) => {
      refreshing.value = false;
      if (res) {
        signCount.value = res.monthSignCount;
        signList.value = res.list;
      }
    })
    .catch(() => {
      refreshing.value = false;
    });
};
onMounted(() => {
  // refreshing.value = true;
  onRefresh();
});
</script>

<style scoped>
.tag {
  font-size: 16px;
  font-weight: normal;
}
.tag .highlight {
  font-weight: 700;
  color: #1989fa;
}
</style>
